import styles from './style.module.css';
import loadingIcon from '../../../assets/images/logoxx88.png';

export default function PageLoading() {
  return (
    <div className={`w-100 d-flex justify-content-center align-items-center ${styles.loadingContainer}`}>
      <div className={`col-md-4 col-10`}>
        <img className={`w-100 ${styles.loadingIcon}`} src={loadingIcon} alt="loading-icon" />
      </div>
    </div>
  )
}